import React, { Fragment, useEffect } from 'react';
import { useTranslation } from "react-i18next";

// import openSocket from 'socket.io-client';
// import { io } from "socket.io-client";
import { io } from 'socket.io-client';

import { useStore } from '../../hook-store/store';

import { TEXTAUDIOTOOLSNODE_URL } from '../../App';
// import classes from './PostSelect.module.css';

let socket;

function TranscribeAudioSocket(props) {
  const { uploadApp } = props;

  const [t] = useTranslation("translation");

  const [store, dispatch] = useStore();
  // const { bucketName, currentPrefix } = store.bucketObjectStore;
  const { isAuth } = store.uiStore;
  const { 
    mlSpeechIsUserGenerating,
    mlSpeechIsServerBusy,
  } = store.mlSpeechStore;
  
  
  //// handle speech to text processing
  useEffect(() => {
      // dispatch('SET_ISVOICEGENERATING', false);

      socket = io.connect(TEXTAUDIOTOOLSNODE_URL, {
        // reconnection: true,
        extraHeaders: {
          // "my-custom-header": "1234",
          "header-client": 'text-audio-tools-frontend',
        }
      });

      // console.log('before socket.on connect')
      socket.on("connect", () => {
        console.log('connect socket.id', socket.id);
        
        //// when connect to nodejs initialize busy state
        dispatch('SET_MLSPEECHISSERVERBUSY', false);

        socket.emit('user-id', {
          socketId: socket.id,
          userId: localStorage.getItem('userId'),
          token: localStorage.getItem('token'),
        });
      });

      socket.on("disconnect", (data) => {
        console.log('disconnect data', data);

        // dispatch('SET_MLSPEECHISSERVER', false);
      });

      socket.on("upload-nodejs-start", (data) => {
        console.log('upload-nodejs-start data', data);

        dispatch('SET_MLSPEECHISSERVERBUSY', true);
      });

      // socket.on("upload-nodejs-finish", (data) => {
      //   console.log('upload-nodejs-finish data', data);

      //   dispatch('SET_MLSPEECHISSERVERBUSY', true);
      // });

      socket.on("stt-processing", (data) => {
        console.log('stt-processing data', data);

        dispatch('SET_MLSPEECHISSERVERBUSY', true);
      });

      socket.on("stt-processing-finish", (data) => {
        console.log('stt-processing-finish data', data);

        dispatch('SET_MLSPEECHISSERVERBUSY', false);
      });

      socket.on("stt-processing-error", (data) => {
        console.log('stt-processing-error data', data);

        dispatch('SET_MLSPEECHISSERVERBUSY', false);
      });


      socket.on("large-file-upload-progress", (data) => {
        console.log('large-file-upload-progress data', data);

        if (window.location.origin === data.origin && uploadApp === data.uploadApp) {
          const progressPct = data.processed / data.totalChunks * 100
          // dispatch('SET_MLSPEECHISSERVERBUSY', true);
          dispatch('SHOW_NOTIFICATION', {
            status: '',
            title: `${t('audioTranscriber40', 'uploading...')} ${progressPct.toFixed(0)}%`,
            message: '',
          });
        }
      });
      
      socket.on("large-file-upload-finish", (data) => {
        console.log('large-file-upload-finish data', data);

        if (window.location.origin === data.origin && uploadApp === data.uploadApp) {
          dispatch('SHOW_NOTIFICATION', {
            status: '',
            title: `${t('audioTranscriber41', 'upload finished')}, ${t('audioTranscriber42', 'file processing...')}`,
            message: '',
          });
        }
      });

      // //// test server exist response from stt server
      // socket.on("stt_server_test_response", (data) => {
      //   console.log('stt_server_test_response data', data);

      //   dispatch('SET_MLSPEECHISSERVER', true);
      // });

      // //// when connected to stt server
      // socket.on("stt-server-connect", (data) => {
      //   console.log('stt-server-connect data', data);

      //   dispatch('SET_MLSPEECHISSERVER', true);
      // });

      // //// when disconnected to stt server
      // socket.on("stt-server-disconnect", (data) => {
      //   console.log('stt-server-disconnect data', data);
        
      //   dispatch('SET_MLSPEECHISSERVER', false);
      // });


      // socket.on("stt_progress", (data) => {
      //   console.log('stt_progress data', data, Date.now());

      //   dispatch('SET_MLSPEECHISSERVERBUSY', true);
      // });

      // socket.on("stt_processing", (data) => {
      //   console.log('stt_processing data', data);
        
      //   dispatch('SET_MLSPEECHISSERVERBUSY', true);
      // });

      // socket.on("stt_processing_start", (data) => {
      //   console.log('stt_processing_start data', data);

      //   dispatch('SET_MLSPEECHISSERVERBUSY', true);
      // });

      // socket.on("stt_processing_finish", (data) => {
      //   console.log('stt_processing_finish data', data);
        
      //   dispatch('SET_MLSPEECHISSERVERBUSY', false);
      // });

      // socket.on("stt_processing_error", (data) => {
      //   console.log('stt_processing_error data', data);

      //   dispatch('SET_MLSPEECHISSERVERBUSY', false);
      // });


      return () => {
        socket.off('connect')
        socket.off('disconnect')
        // socket.off('stt_server_test_response')
        // socket.off('stt-server-connect')
        // socket.off('stt-server-disconnect')
        socket.off('upload-nodejs-start')
        socket.off('upload-nodejs-finish')
        
        socket.off('large-file-upload-progress')
        socket.off('large-file-upload-finish')
        
        // socket.off('stt_progress')
        // socket.off('stt_finish')
  
        // socket.off('stt_processing')
        // socket.off('stt_processing_start')
        // socket.off('stt_processing_error')
        // socket.off('stt_processing_finish')

        socket.off('stt-processing-finish')
        socket.off('stt-processing-error')
        // socket.off('stt-start-response');
        // socket.off('run_params')
      }
  },[]);


  // //// handle speech to text start
  // useEffect(() => {

  //     socket.on("stt-start-response", (data) => {
  //       console.log('stt-start-response data', data);
  //       dispatch('SET_MLSPEECHISSERVERBUSY', true);
  //     });
    

  //     if (mlSpeechIsUserGenerating) {
  //       socket.emit('stt-start', {
  //         socketId: socket.id,
  //         userId: localStorage.getItem('userId'),
  //         time: Date.now(),
  //         // token: localStorage.getItem('token'),
  //       });

  //       dispatch('SET_MLSPEECHISSERVERBUSY', true);

  //     } else {
  //       dispatch('SET_MLSPEECHISSERVERBUSY', false);
  //     }

  //     return () => {
  //       socket.off('stt-start-response');
  //     }
  // },[mlSpeechIsUserGenerating]);

  return (
    <Fragment></Fragment>
  );
}

export default TranscribeAudioSocket;